$(document).ready(function () {
  let p = $("body").attr("p");
  if (p === "organizer_location") {
    $(document).on("change", "#use_as_admin", function () {
      $("#use-as-admin-confirm-model").modal("show");
    });

    $(document).on(
      "click",
      "#use-as-admin-confirm , #use-as-normal-confirm",
      function () {
        const isUseAsAdmin = $("#use_as_admin").is(":checked");
        const locationId = $("#use_as_admin").attr("data-location-id");
        const userId = $("#use_as_admin").attr("data-user-id");
        const deviceId = $("#use_as_admin").attr("data-current-device-id");
        const locationUserDeviceSettingId =
          $("#use_as_admin").attr("data-location-user-device-setting-id") ||
          null;
        const confirmBtn = $(this);
        const cancelBtn = $("#use-as-admin-cancel");

        const btnWidth = confirmBtn.outerWidth();
        confirmBtn.css("width", btnWidth + "px");
        confirmBtn.prop("disabled", true);
        cancelBtn.prop("disabled", true);
        confirmBtn.html('<i class="spinner-border spinner-border-sm"></i>');
        setUserdeviceSetting(
          locationId,
          userId,
          deviceId,
          locationUserDeviceSettingId,
          isUseAsAdmin ? 1 : 0,
        ).always(function () {
          $("#use-as-admin-confirm-model").modal("hide");
          confirmBtn.prop("disabled", false);
          cancelBtn.prop("disabled", false);
          confirmBtn.text("Bekreft");
        });
      },
    );

    $(document).on("click", "#use-as-admin-cancel", function () {
      const isUseAsAdmin = $("#use_as_admin").is(":checked");
      $("#use_as_admin").prop("checked", !isUseAsAdmin);
    });

    function setUserdeviceSetting(
      locationId,
      userId,
      deviceId,
      locationUserDeviceSettingId,
      useAsAdmin = 0,
    ) {
      return $.ajax({
        type: "POST",
        url: "/api/v1/private/organizer-location/set-use-as-admin",
        data: {
          location_id: locationId,
          user_id: userId,
          device_id: deviceId,
          location_user_device_setting_id: locationUserDeviceSettingId,
          use_as_admin: useAsAdmin,
        },
      })
        .done(function (data) {
          if (data && data.success) {
            $("#use-as-admin-confirm-model").modal("hide");
            popupAlert();
          }
        })
        .fail(function (data) {
          if (data.responseJSON) {
            prependAlert(
              "#message-box",
              data.responseJSON,
              "danger",
              null,
              "#organizer-location-reg-form",
            );
          }
          $("#use-as-admin-confirm-model").modal("hide");
        });
    }
  }
});
